import { createContext, useCallback, useContext, useState } from "react";

const KEY = "mn_cart";
const Ctx = createContext(null);
const load = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) ?? [];
  } catch {
    return [];
  }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const save = useCallback((fn) => setItems((p) => {
    const next = fn(p);
    localStorage.setItem(KEY, JSON.stringify(next));
    return next;
  }), []);
  const add = useCallback((item) => save((p) => [...p, { ...item, key: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}` }]), [save]);
  const remove = useCallback((key) => save((p) => p.filter((i) => i.key !== key)), [save]);
  const removeMany = useCallback((keys) => save((p) => p.filter((i) => !keys.includes(i.key))), [save]);
  return <Ctx.Provider value={{ items, add, remove, removeMany }}>{children}</Ctx.Provider>;
}

export const useCart = () => useContext(Ctx);
